import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme.js';

const PLAY_ICON = require('./play.svg');
const NEXT_ICON = require('./next.svg');
const PREVIOUS_ICON = require('./previous.svg');
const VOLUME_ICON = require('./volume.svg');
const PAUSE_ICON = require('./pause.svg');
const MUTED_ICON = require('./muted.svg');

export default class TrackControl extends Component {
  static defaultProps = {
    'visible': true,
    'type': 'play',
    'handler': () => {}
  };

  render() {
    let icon;

    switch(this.props.type) {
      default:
        icon = PLAY_ICON;
        break;
      case 'play':
        icon = PLAY_ICON;
        break;
      case 'next':
        icon = NEXT_ICON;
        break;
      case 'previous':
        icon = PREVIOUS_ICON;
        break;
      case 'volume':
        icon = VOLUME_ICON;
        break;
      case 'pause':
        icon = PAUSE_ICON;
        break;
      case 'muted':
        icon = MUTED_ICON;
        break;
    }

    return (
      <div className={css(styles.container)}>
        <img
          onClick={this.props.handler.bind(this)}
          className={css(styles.icon, this.props.visible ? styles.visible : styles.invisible)}
          src={icon} />
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 17,
    height: 17,
    marginLeft: 15,
    marginRight: 15,
  },
  icon: {
    position: 'relative',
    width: 17,
    height: 17,
    cursor: 'pointer',
    transition: 'all 150ms ease-in-out',

    ':hover': {
      opacity: 0.7,
    },
  },
  visible: {

  },
  invisible: {
    display: 'none',
  },
})



// WEBPACK FOOTER //
// ./src/components/TrackControl/index.js